import React from "react";
import "./AchievementCard.css";
import { Fade } from "react-reveal";

const imageMap = {
  "Ncc.png": require("../../assets/images/Ncc.png"),
};

export default function AchievementCard({ cardInfo, theme }) {
  function openUrlInNewTab(url) {
    if (url) {
      var win = window.open(url, "_blank");
      win.focus();
    }
  }

  if (!cardInfo) return null;

  const cardImage = cardInfo.image ? imageMap[cardInfo.image] : null;

  return (
    <div
      className="certificate-card"
      style={{ backgroundColor: theme ? theme.highlight : "#ffffff" }}
    >
      <Fade bottom duration={2000} distance="40px">
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div className="certificate-image-div">
            {cardImage && (
              <img
                src={cardImage}
                alt={cardInfo.alt_name || "Achievement"}
                className="card-image"
              />
            )}
          </div>
          <div className="certificate-detail-div">
            <h5
              className="card-title"
              style={{ color: theme ? theme.text : "#000" }}
            >
              {cardInfo.title || ""}
            </h5>
            <p
              className="card-subtitle"
              style={{ color: theme ? theme.text : "#666" }}
            >
              {cardInfo.description || ""}
            </p>
          </div>
          {cardInfo.footer && cardInfo.footer.length > 0 && (
            <div className="certificate-card-footer">
              {cardInfo.footer.map((v, i) => {
                return (
                  <p key={i} onClick={() => openUrlInNewTab(v.url)}>
                    {v.name}
                  </p>
                );
              })}
            </div>
          )}
        </div>
      </Fade>
    </div>
  );
}
